import styled from 'styled-components';

export const DatePickerStyled = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  .datePicker {
     &__title {
      display: inline-flex;
      width: 50%;
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeS};
      line-height: 19px;
      color: ${props => props.theme.uiColors.schedulePartingDatePickerTitle};
    };

    &__inputContainer {
      display: flex;
      flex-direction: row;
      gap: var(--spacing-16);
    }
      
    &__infoContainer {
      .singleSelectWrapper {
        width: 180px;
      }
      .timezone-select {
        cursor: pointer;
      }
    }

    &.withError {
      margin-bottom: 0;
    }
  }
`;
